/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : Layout.tsx
// 설명 : 레이아웃 컴포넌트
//  - 전체 페이지의 레이아웃을 구성합니다.
//  - 공통 헤더, 사이드바, 푸터 등을 포함합니다.
// 최종수정일 : 2025-08-12
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react';
import { Outlet } from 'react-router-dom';

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// 메인콤포넌트 : React
////////////////////////////////////////////////////////////////////////////////////////////////////////////
const Layout: React.FC = () => {

  return (
    <div className="layout">
        {/* Main Content */}
        <div className="nav-container">
                <Outlet />
        </div>
    </div>
  );
};

export default Layout;
